const mainColor = '#39e3df'

const options = {
    leftTop: data => {
        return {
            title: {
                text: '',
                left: 20,
                top: 40,
                textStyle: {
                    color: '#fff'
                }
            },
            tooltip: {
                trigger: 'item',
                formatter: '{b}<br/>{c}'
            },
            series: {
				top: 20,
                type: 'pie',
                radius: data.Sradius || [70, 160],
                center: ['50%', '50%'],
                data: data.yData,
				roseType: 'area',
                label: {
                    show: true,
					textStyle: {
						fontSize: data.fontSize || 16
					},
                    // color: '#fff',
                    formatter: '{b}\n{d}%'
                },               
                itemStyle: {
                    color: ({dataIndex}) =>
                        [
                            '#1890FF',
                            '#F5E055',
                            '#FF9565',
                            '#F3497D',
                            '#63F9F9',
                            '#B980FE',
							'#EC772E'
                        ][dataIndex % 7]
                },
            }
        }
    },
	leftTopBottom: data => {
		return {
			tooltip: {
			    trigger: 'axis',
			    axisPointer: {
					type: 'shadow'
			    },
				formatter: '{b0}: {c0}'
			},
			grid: data.grid || {
			    left: '15%',
			    right: '15%',
			    bottom: '10%',
				top: '10%',
			    containLabel: true
			},
			textStyle: {
				color: "#ffffff"
			},
			xAxis: {
			    type: 'value',				
				splitLine: {
					show: false,
					lineStyle: {
						type: 'dashed',
						color: '#CCCCCC',
						opacity: 0.3
					}
				},
				axisLine: {
					show: false
				},
				axisLabel: {
					textStyle: {
						fontSize: data.fontSize || 16
					},
				}
			},
			yAxis: {
				offset: 20,
			    type: 'category',
			    data: data.xData || [5, 4, 3, 2, 1],
				splitLine: {
					show: false,
					lineStyle: {
						type: 'dashed',
						color: '#CCCCCC',
						opacity: 0.3
					}
				},
				axisLine: {
					show: false
				},
				axisLabel: {
					textStyle: {
						fontSize: data.fontSize || 16
					},
				}
			},
			series: {
				type: 'bar',
				data: data.yData.reverse(),
				barWidth: data.barWidth || 8,
				barGap: 1,
				label: {
					show: true,
					position: 'right'
				},
				itemStyle: {					
					normal: {
						label: {
							show: true, 
							position: 'right',
							formatter: data.formatter || '{b0}',
							textStyle: {
								fontSize: data.fontSize || 16,
								rich: data.rich || {}
							},
						},
						color: {
							type: 'linear',
							x: 0,
							y: 0,
							x2: 1,
							y2: 0,
							colorStops: [
								{
									offset: 0,
									color: "#002C8C"
								},
								{
									offset: 1,
									color: "#91CAFF"
								}
							]
						},						
						// barBorderRadius: [0, 4, 4, 0],
					},
					emphasis: data.emphasis || {}
				}
			}			
		}
	},
    leftCenter: data => {
        return {
			grid: data.grid || {
				top: '10%',
				left: '20%',
				right: '15%',					
			},
            tooltip: {
                trigger: 'axis',
                axisPointer: {
                    type: 'shadow'
                }
            },
            xAxis: {
                type: 'category',
				offset: 10,
                data: data.xData,	
				splitLine: {
					show: false,
					lineStyle: {
						type: 'dashed',
						color: '#CCCCCC',
						opacity: 0.3
					}
				},
				axisLine: {
					show: false
				},
                axisLabel: data.XaxisLabel || {
                    rotate: 0,
                    interval: 0,
                    color: '#fff',
                    formatter: value => value.replace(/\s/g, '\n'),
					textStyle: {
						fontSize: data.fontSize || 16,
						color: '#fff'
					},
                }
            },
            yAxis: {
                type: 'value',
				offset: 10,
				splitLine: {
					show: false,
					lineStyle: {
						type: 'dashed',
						color: '#CCCCCC',
						opacity: 0.3
					}
				},
				axisLine: {
					show: false
				},
				axisTick: {
					show: false
				},
                axisLabel: data.YaxisLabel || {
					fontSize: data.fontSize || 16,
                    color: '#fff',
                }
            },
            series: {
                type: 'bar',
                data: data.yData,
                barWidth: data.barWidth || 8,
                label: {
                    show: true,
                    position: 'top',
                    color: '#F5E055',
					textStyle: {
						fontSize: data.fontSize || 16,
						fontWeight: 900
					},
					formatter: data.formatter || '{c0}',
                },
                itemStyle: {
                	color: {
                		type: 'linear',
                		x: 0,
                		y: 0,
                		x2: 0,
                		y2: 1,
                		colorStops: [
                			{
                				offset: 0,
                				color: "#91CAFF"
                			},
                			{
                				offset: 1,
                				color: "#002C8C"
                			}
                		]
                	},
                	barBorderRadius: data.barBorderRadius || [0, 0, 0, 0],
                },
            }
        }
    },
    leftBottom: data => {
        return {
            grid: {
                left: '10%',
                right: '10%',
                bottom: '10%',
				top: '10%'
            },
			textStyle: {
				color: "#ffffff"
			},
            xAxis: {
				type: 'value',				
				// boundaryGap: [0, 0.01],		
				splitLine: {
					show: false,
					lineStyle: {
						type: 'dashed',
						color: '#CCCCCC',
						opacity: 0.3
					}
				},
				axisLine: {
					show: false
				},
				axisTick: {
					show: false
				},
				axisLabel: data.XaxisLabel || {
					color: '#fff',
					textStyle: {
						fontSize: data.fontSize || 16
					},
				}
            },
            yAxis: {
				type: 'category',
				offset: 10,
				data: data.xData || [5, 4, 3, 2, 1],
				splitLine: {
					show: false,
					lineStyle: {
						type: 'dashed',
						color: '#CCCCCC',
						opacity: 0.3
					}
				},
				axisLine: {
					show: false
				},
				axisLabel: data.YaxisLabel || {
					color: '#fff',
					textStyle: {
						fontSize: data.fontSize || 16
					},
				}
            },
            series: {
                type: 'bar',
                data: data.yData.reverse(),
				label: {
					show: true,
					position: 'top',
					color: '#fff',
					textStyle: {
						fontSize: data.fontSize || 16,
						fontWeight: 900,
						
					},
				},
                barWidth: data.barWidth || 8,
                itemStyle: {
                	normal: {
                		label: {
                			show: true, 
                			formatter: data.formatter || '{b0}',
							textStyle: {
								fontSize: data.fontSize || 16,
								rich: data.rich || {}
							},
							position: data.labelPositon || '',
                		},
                		color: {
							type: 'linear',
							x: 0,
							y: 0,
							x2: 1,
							y2: 0,
							colorStops: [
								{
									offset: 0,
									color: "#002C8C"
								},
								{
									offset: 1,
									color: "#91CAFF"
								}
							]
						},
						// barBorderRadius: [0, 4, 4, 0]
                	}
                }
            },
            tooltip: {
                trigger: 'axis',
                axisPointer: {
                    type: 'shadow'
                },
				formatter: '{b0}: {c0}',
				textStyle: {
					fontSize: data.fontSize || 16
				},
            },
        }
    },
    rightTop: data => {
        return {
            series: {
                type: 'pie',
				top: 30,
				radius: ['40%', '85%'],
				center: ['50%', '50%'],
                color: mainColor,				
                data: data.yData,  
				labelLine: {
					// show: false,
				},
				label: {
				    show: true,
					textStyle: {
						fontSize: data.fontSize || 16
					},
				    // color: '#fff',
				    formatter: '{b}\n{d}%'
				},
				itemStyle: {
				    color: ({dataIndex}) =>
				        [
				            '#F5E055',
				            '#FF9565',
				            '#F3497D',
				            '#63F9F9',
				            '#1890FF',
				        ][dataIndex % 5]
				},
            },
        }
    },
    rightCenter: data => {
        return {
            grid: data.grid || {
                left: '25%',
                right: '10%',
                top: '8%',
				bottom: '25%'
            },
			legend: {
				show: data.legend || false,
				textStyle: {
					color: '#fff',
					fontSize: 24
				},
				right: 280
			},
            xAxis: {
                type: 'category',
                data: data.xData,
				offset: 10,
                axisLabel: {
                    show: true,
                    interval: 0,
                    color: mainColor,
                    rotate: 30,
					textStyle: {
						fontSize: data.fontSize || 14,
						color: "#fff"
					},
					margin: data.Xmargin || 8,
					align: data.Xalign || ''
                },
				splitLine: {
					show: false,
					lineStyle: {
						type: 'dashed',
						color: '#CCCCCC',
						opacity: 0.3
					}
				},
				axisLine: {
					show: false
				}
            },
            yAxis: {
                type: 'value',	
				offset: 20,
                axisLabel: {
                    color: mainColor,
					textStyle: {
						fontSize: data.fontSize || 14,
						color: "#fff"
					}
                },
				splitLine: {
					show: false,
					lineStyle: {
						type: 'dashed',
						color: '#CCCCCC',
						opacity: 0.3
					}
				},
				axisTick: {
					show: false
				},
				axisLine: {
					show: false
				}
            },
            series: data.series || {
                type: 'bar',
                data: data.yData,
                barWidth: data.barWidth || 8,
                label: {
                    show: true,
                    position: 'top',
                    color: '#fff',
					textStyle: {
						fontSize: data.fontSize || 14
					}
                },
                itemStyle: {
					color: {
						type: 'linear',
						x: 0,
						y: 0,
						x2: 0,
						y2: 1,
						colorStops: [
							{
								offset: 0,
								color: "#91CAFF"
							},
							{
								offset: 1,
								color: "#002C8C"
							}
						]
					},
					barBorderRadius: data.barBorderRadius || [0, 0, 0, 0],
                },
                emphasis: {
                    focus: 'series'
                },
            },
            tooltip: {
                trigger: 'axis',
                axisPointer: {
                    type: 'shadow'
                },
				textStyle: {
					fontSize: data.fontSize || 14
				}
            },
        }
    },
    rightBottom: data => {
        return {
            grid: data.grid || {
                left: '5%',
                right: '5%',
                bottom: '15%',
                top: '10%'
            },
            tooltip: {
                trigger: 'axis',
                axisPointer: {
                    type: 'shadow'
                },
				textStyle: {
					fontSize: data.fontSize || 16,
				}
            },
			legend: data.legend || '',
            xAxis: {
                type: 'category',
                data: data.xData,
				offset: 10,
                axisLabel: data.XaxisLabel || {
                    // rotate: 30,
                    interval: 0,
                    color: '#fff',
                    formatter: value => value.replace(/\s/g, '\n'),
					textStyle: {
						fontSize: data.fontSize || 16,
						color: '#fff'
					}
                },
				splitLine: {
					show: false,
					lineStyle: {
						type: 'dashed',
						color: '#CCCCCC',
						opacity: 0.3
					}
				},
				axisLine: {
					show: false
				}
            },
            yAxis: [ data.yAxis1 ||
                {
                    type: 'value',
                    show: false,
                    axisLabel: {
                        color: '#fff',
						textStyle: {
							fontSize: data.fontSize || 16,
							color: '#fff'
						}
                    },
					splitLine: {
						show: false,
						lineStyle: {
							type: 'dashed',
							color: '#CCCCCC',
							opacity: 0.3
						}
					},
					axisLine: {
						show: false
					}
                },
				data.yAxis2 ||
                {
                    type: 'value',
                    name: '',
                    min: 0,
                    max: 100,
                    axisLabel: {show: false},
					splitLine: {
						show: false,
						lineStyle: {
							type: 'dashed',
							color: '#CCCCCC',
							opacity: 0.3
						}
					},
					axisLine: {
						show: false
					}
                }
            ],
            series: [
                {
                    type: 'bar',
                    data: data.yData[0],
                    name: '申请量',
                    barWidth: data.barWidth || 8,
					label: data.YLabel1 || {
					   
					},
					barGap: data.barGap || '250%',
					barCategoryGap: data.barCategoryGap || '100%',
                    itemStyle: {
                        color: {
                        	type: 'linear',
                        	x: 0,
                        	y: 0,
                        	x2: 0,
                        	y2: 1,
							colorStops: [
								{
									offset: 0,
									color: "#FFFB8F"
								},
								{
									offset: 1,
									color: "#876800"
								}
							]                        	
                        },
						barBorderRadius: data.barBorderRadius || [0, 0, 0, 0]
                    }
                },
                {
                    type: 'bar',
                    data: data.yData[1],
                    name: '注册量',
                    barWidth: data.barWidth || 8,
                    label: data.YLabel2 || {
                       
                    },
                    itemStyle: {
						color: {
							type: 'linear',
							x: 0,
							y: 0,
							x2: 0,
							y2: 1,
							colorStops: [
								{
									offset: 0,
									color: "#91CAFF"
								},
								{
									offset: 1,
									color: "#002C8C"
								}
							]
						},
						barBorderRadius: data.barBorderRadius || [0, 0, 0, 0]
                    }
                }, data.lv ||
                {
                    type: 'line',
                    data: data.yData[2],
                    yAxisIndex: 1,
                    name: '注册成功率',
                    formatter: '{value}%',
					symbolSize: data.symbolSize || 10, 
                    smooth: true,
                    label: {
                        show: true,
                        position: 'top',
                        formatter(params) {
                            let {value} = params
                            return value + '%'
                        },
                        color: '#fff',
						textStyle: {
							fontSize: data.fontSize || 14
						}
                    },
                    itemStyle: {                        
						normal: {
							lineStyle: {
								color: '#18F8FF',
								width: 2
							}
						}						
                    }
                }
            ]
        }
    },
    // centerCenter: data => {
    //     return {
    //         title: {
    //             text: data.title,
    //             left: 'center',
    //             textStyle: {
    //                 color: '#fff'
    //             }
    //         },
    //         legend: {
    //             right: 100,
    //             data: ['事件数量', '告警数量'],
    //             textStyle: {
    //                 color: '#fff'
    //             }
    //         },
    //         grid: {
    //             left: 15,
    //             right: 15,
    //             top: 40,
    //             bottom: 40,
    //             containLabel: true
    //         },
    //         xAxis: {
    //             type: 'category',
    //             data: data.xData,
    //             boundaryGap: false,
    //             splitLine: {
    //                 show: true,
    //                 lineStyle: {
    //                     type: 'dashed'
    //                 }
    //             },
    //             axisLabel: {
    //                 color: '#fff'
    //             }
    //         },
    //         yAxis: {
    //             type: 'value',
    //             interval: 50,
    //             splitLine: {
    //                 lineStyle: {
    //                     type: 'dashed'
    //                 }
    //             },
    //             axisLabel: {
    //                 color: '#fff'
    //             }
    //         },
    //         series: [
    //             {
    //                 name: '事件数量',
    //                 type: 'line',
    //                 lineStyle: {
    //                     color: '#c23531'
    //                 },
    //                 areaStyle: {
    //                     color: '#c23531'
    //                 },
    //                 data: data.yEventData
    //             },
    //             {
    //                 name: '告警数量',
    //                 type: 'line',
    //                 lineStyle: {
    //                     color: '#2f4554'
    //                 },
    //                 areaStyle: {
    //                     color: '#2f4554'
    //                 },
    //                 data: data.yAlarmData
    //             }
    //         ]
    //     }
    // },
    centerTopLeft: data => {
        return {
            series: {
                type: 'gauge',
                radius: 60,
                center: ['50%', '50%'],
                axisLine: {
                    lineStyle: {
                        width: 25,
                        color: [
                            [0.5, '#DD3F36'],
                            [0.7, '#FAE521'],
                            [1, '#37B70C']
                        ]
                    }
                },
                axisTick: {
                    show: false
                },
                axisLabel: {
                    distance: 0,
                    fontSize: 10,
                    color: '#fff'
                },
                itemStyle: {
                    color: '#fff'
                },
                detail: {
                    offsetCenter: ['0%', '80%'],
                    color: '#fff',
                    fontSize: 14,
                    formatter: value => (value > 70 ? '健康' : '不健康')
                },
                data: [data]
            }
        }
    }
}

export function getChartOption(name, data) {
    if (options[name]) return options[name](data)
    return false
}
